<div style='position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;width:900px;height:fit-content;text-align:center;font-family:\"Exo2SemiBold\",sans-serif;line-height:50px;'>
  <b style='display:block;font-size:32px;'>
    Добридень!<br>
    Нажаль, ваш доступ до інформації на сайті  був автоматично обмежений через відсутність замовлень.<br>
    Для відновлення доступу, зверніться до адміністратору сайту за номером:<br>
    +380 (50) 982 18 29
  </b>
</div>
